import CustomBreadCrumb from "../../components/breadcrumb";
import { ROUTES } from "../../constants/routes";
import { ROLES_CODE } from "../../constants/roles";
import withAuth from "../../HOC/withAuth";
import withRole from "../../HOC/withRole";

import { PageRoot } from "./styles/theme";
import { Main } from "./styles/index.styles";
import usePilotageRh from "./hooks/usePilotageRh";
import useExportDialog from "./hooks/useExportDialog";

import FilterBar from "./components/FilterBar/FilterBar";
import ExportDialog from "./components/ExportDialog/ExportDialog";
import { GlobalTooltip } from "./components/ui/Tooltip/Tooltip";

import EffectifSection from "./components/sections/EffectifSection";
import DiversiteSection from "./components/sections/DiversiteSection";
import RetentionSection from "./components/sections/RetentionSection";
import MouvementsSection from "./components/sections/MouvementsSection";
import AbsencesSection from "./components/sections/AbsencesSection";
import TempsSection from "./components/sections/TempsSection";
// import EngagementSection from "./components/sections/EngagementSection";
import FraisSection from "./components/sections/FraisSection";
import TachesSection from "./components/sections/TachesSection";

const PilotageRh = () => {
    const {
        effectif,
        diversite,
        retention,
        mouvements,
        absences,
        temps,
        frais,
        taches,
        isFetching,
    } = usePilotageRh();
    const exportDialog = useExportDialog();

    return (
        <PageRoot>
            <CustomBreadCrumb
                navList={[
                    { label: "Pilotage RH", href: ROUTES.pilotage_rh.home },
                ]}
            />

            <FilterBar onExport={exportDialog.dialog.openDialog} />

            <Main $loading={isFetching}>
                <EffectifSection
                    data={effectif.data}
                    isLoading={effectif.isLoading}
                />
                <DiversiteSection
                    data={diversite.data}
                    isLoading={diversite.isLoading}
                />
                <RetentionSection
                    data={retention.data}
                    isLoading={retention.isLoading}
                />
                <MouvementsSection
                    data={mouvements.data}
                    isLoading={mouvements.isLoading}
                />
                <AbsencesSection
                    data={absences.data}
                    isLoading={absences.isLoading}
                />
                <TempsSection data={temps.data} isLoading={temps.isLoading} />
                {/* <EngagementSection data={metrics.engagement} /> */}
                <FraisSection data={frais.data} isLoading={frais.isLoading} />
                <TachesSection
                    data={taches.data}
                    isLoading={taches.isLoading}
                />
            </Main>

            <ExportDialog logic={exportDialog} />
            <GlobalTooltip />
        </PageRoot>
    );
};

export default withAuth(
    withRole([ROLES_CODE.hr, ROLES_CODE.admin, ROLES_CODE.ceo])(PilotageRh)
);
